if (!customElements.get('mlt-product')) {
  customElements.define('mlt-product', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      this.on = (el, type, fn) => el.addEventListener(type, fn, { signal: this.controller.signal });
      this.find = s => this.querySelector(s);
      this.form = this.find('form');
      this.option = this.find('[data-option]');
      this.number = this.find('[data-number]');
      this.custom = this.find('textarea[data-custom]');
      this.saying = this.find('[data-saying]');
      this.submit = this.find('[data-submit]');
      this.dialog = this.find('[data-dialog]');
      this.search = this.find('[data-search]');
      this.results = this.find('[data-results]');
      this.labels = JSON.parse(this.find('[data-labels]').textContent);
      this.page = 1;
      this.pageSize = 16;
      this.category = 'favorites';
      this.rows = [];
      this.filtered = [];
      this.on(this.option, 'change', () => this.sync());
      this.on(this.number, 'input', () => this.sync());
      this.on(this.custom, 'input', () => this.sync());
      this.on(this.find('[data-open]'), 'click', () => {
        this.page = 1;
        this.search.value = '';
        this.category = 'favorites';
        this.filter();
        this.dialog.showModal();
        this.search.focus();
      });
      this.on(this.find('[data-close]'), 'click', () => this.dialog.close());
      this.on(this.search, 'input', () => { this.page = 1; if (this.search.value.trim()) this.category = 'all'; this.filter(); });
      this.on(this.find('[data-categories]'), 'click', e => {
        const b = e.target.closest('[data-category]');
        if (!b) return;
        this.category = b.dataset.category; this.search.value = ''; this.page = 1; this.filter();
      });
      this.on(this.find('[data-reset]'), 'click', () => { this.search.value = ''; this.category = 'all'; this.page = 1; this.filter(); this.search.focus(); });
      this.on(this.find('[data-prev]'), 'click', () => { this.page--; this.render(); });
      this.on(this.find('[data-next]'), 'click', () => { this.page++; this.render(); });
      this.on(this.results, 'click', e => {
        const b = e.target.closest('[data-choose]');
        if (!b) return;
        this.number.value = b.dataset.choose;
        this.sync();
        this.dialog.close();
        this.find('[data-selection]').scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.number.focus({ preventScroll: true });
      });
      this.on(this.form, 'submit', e => {
        this.sync();
        if (this.submit.disabled || !this.form.checkValidity()) {
          e.preventDefault();
          this.form.reportValidity();
        }
      });
      this.querySelectorAll('[data-image-url]').forEach(b => this.on(b, 'click', () => {
        const hero = this.find('.mlt__hero');
        hero.removeAttribute('srcset');
        hero.src = b.dataset.imageUrl;
        hero.alt = b.dataset.imageAlt;
        this.querySelectorAll('[data-image-url]').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      }));
      this.sync();
      fetch(this.dataset.sayingsUrl, { credentials: 'same-origin' })
        .then(r => { if (!r.ok) throw new Error('load'); return r.json(); })
        .then(rows => {
          if (!Array.isArray(rows) || rows.length !== 757 || rows.some((r, i) => r.number !== i + 1 || typeof r.phrase !== 'string')) throw new Error('data');
          this.rows = rows;
          this.find('[data-open]').disabled = false;
          this.sync();
        })
        .catch(error => {
          console.error('Saying guide load failed:', error);
          this.find('[data-error]').textContent = this.labels.product.load_error;
          this.find('[data-error]').hidden = false;
        });
    }
    disconnectedCallback() { this.controller?.abort(); this.bound = false; }
    sync() {
      const o = this.option.selectedOptions[0];
      const customMode = o?.dataset.custom === 'true';
      this.find('p[data-price]').textContent = o?.dataset.price || '';
      this.find('[data-numbered-panel]').hidden = customMode;
      this.find('[data-custom-panel]').hidden = !customMode;
      this.number.disabled = customMode;
      this.number.required = !customMode;
      this.saying.disabled = customMode;
      this.custom.disabled = !customMode;
      this.custom.required = customMode;
      const text = this.custom.value.trim();
      const words = text ? text.split(/\s+/u).length : 0;
      const customValid = words > 0 && words <= 10 && this.custom.value.length <= 60;
      this.custom.setCustomValidity(words > 10 ? this.labels.product.too_many_words : '');
      this.find('[data-counter]').textContent = this.labels.product.counter.replace('[words]', words).replace('[chars]', this.custom.value.length);
      const row = this.rows.find(r => String(r.number) === this.number.value.trim());
      this.saying.value = row ? `MOST LIKELY ${row.phrase}` : '';
      this.find('[data-selection]').textContent = row ? `#${row.number} — MOST LIKELY ${row.phrase}` : this.labels.product.choose_first;
      this.submit.disabled = !o || o.disabled || (customMode ? !customValid : !row);
    }
    filter() {
      const q = this.search.value.trim().toLowerCase();
      const n = q.match(/^#?(\d+)$/);
      const terms = q.split(/\s+/u).filter(Boolean);
      const pool = this.category === 'favorites' ? this.rows.filter(r => r.favorite) : this.category === 'all' ? this.rows : this.rows.filter(r => r.categories?.includes(this.category));
      this.querySelectorAll('[data-category]').forEach(b => b.setAttribute('aria-pressed', String(!q && b.dataset.category === this.category)));
      this.filtered = pool.filter(r => n ? String(r.number) === String(Number(n[1])) : terms.every(t => (`most likely ${r.phrase}`).toLowerCase().includes(t)));
      this.render();
    }
    render() {
      const pages = Math.max(1, Math.ceil(this.filtered.length / this.pageSize));
      this.page = Math.min(Math.max(this.page, 1), pages);
      const start = (this.page - 1) * this.pageSize;
      this.results.replaceChildren();
      this.filtered.slice(start, start + this.pageSize).forEach(r => {
        const card = document.createElement('div'); card.className = 'mlt__result';
        const p = document.createElement('p');
        const num = document.createElement('strong'); num.textContent = `#${r.number}`;
        p.append(num, document.createTextNode(`MOST LIKELY ${r.phrase}`));
        const b = document.createElement('button'); b.type = 'button'; b.dataset.choose = r.number;
        b.textContent = this.labels.guide.choose;
        b.setAttribute('aria-label', this.labels.guide.choose_number.replace('[number]', r.number));
        card.append(p, b); this.results.append(card);
      });
      if (!this.filtered.length) { const p = document.createElement('p'); p.textContent = this.labels.guide.no_results; this.results.append(p); }
      this.find('[data-count]').textContent = this.search.value.trim() ? this.labels.guide.search_count.replace('[count]', this.filtered.length) : this.labels.guide.category_count.replace('[category]', this.labels.guide[this.category]).replace('[count]', this.filtered.length);
      this.find('[data-page]').textContent = this.labels.guide.page.replace('[page]', this.page).replace('[pages]', pages);
      this.find('[data-prev]').disabled = this.page <= 1;
      this.find('[data-next]').disabled = this.page >= pages;
      this.results.scrollTop = 0;
    }
  });
}
